module.exports = __webpack_public_path__ + "static/media/mcd.92c656b5.jpg";